<div class="w-full lg:max-w-7xl p-8">
    <div class="prose prose-sm !max-w-100">
        <h2>{{ 'label_mortgage_eligibility_form' | translatePlural }}</h2>
    </div>

    <mat-divider class="my-4"></mat-divider>

    <div>
        <div id="header" class="flex flex-col flex-auto justify-between py-4 px-6 md:px-8 border-b">
            <!-- Main actions -->
            <div class="flex gap-4 items-center">
                <!-- Search -->
                <div class="flex-auto lg:max-w-4/5">
                    <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full min-w-50">
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
                        <input matInput [placeholder]="'label_search' | translate" (keyup)="searchFilter($event.target.value)" />
                    </mat-form-field>
                    <div class="mr-0.5 float-right mt-0.5 font-medium text-secondary">
                        {{
                            'info_documents_found_count'
                                | translate
                                    : {
                                          count: displayedData.filteredData.length,
                                      }
                        }}
                    </div>
                </div>
                <button class="mb-6" mat-flat-button type="button" [color]="'primary'" (click)="openNewMortgageEligibilityForm()">
                    <mat-icon class="icon-size-5" fontIcon="add" matPrefix></mat-icon>
                    {{ 'label_add_document' | translate }}
                </button>
            </div>
        </div>

        <div class="mat-table-wrapper">
            <table matSort mat-table [dataSource]="displayedData" class="w-full" (matSortChange)="sortData($event)">
                <ng-container matColumnDef="id">
                    <th mat-sort-header="id" mat-header-cell *matHeaderCellDef>#</th>
                    <td mat-cell *matCellDef="let element">
                        <span>
                            <a class="c-link" [matTooltip]="'label_open_document' | translate" [routerLink]="['.', element.id]">{{
                                element.id
                            }}</a>
                        </span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="externalServiceId">
                    <th mat-sort-header="externalServiceId" mat-header-cell *matHeaderCellDef>
                        {{ 'label_case' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.externalServiceId }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="originatingSystem">
                    <th mat-sort-header="originatingSystem" mat-header-cell *matHeaderCellDef>
                        {{ 'label_application' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ 'label_' + element.originatingSystem | translate }} -
                        {{ element.originatingSystemApplicationId }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="property">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ 'label_property' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span>{{ getPropertyDescription(element) }}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-icon class="icon-size-5 relative top-1" fontIcon="more_horiz"></mat-icon>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="flex">
                            <button
                                mat-icon-button
                                type="button"
                                matTooltipShowDelay="500"
                                [matTooltip]="'label_delete' | translate"
                                (click)="onDeleteForm(element)"
                            >
                                <mat-icon class="icon-size-5" fontIcon="delete"></mat-icon>
                            </button>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
                <tr class="mat-row" *matNoDataRow>
                    @if (loaded) {
                        <div class="flex items-center justify-between">
                            <span>
                                <div class="mt-2 ml-2 font-medium text-secondary">
                                    {{ 'info_documents_found_count' | translate: { count: 0 } }}
                                </div>
                            </span>
                        </div>
                    }
                </tr>
            </table>
            <mat-paginator
                #tablePaginator
                class="justify-end"
                showFirstLastButtons
                [pageSize]="pageSize"
                [pageSizeOptions]="[5, 10, 25, 100]"
            >
            </mat-paginator>
        </div>
    </div>
</div>
